var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"word-list12"},[_c('div',{staticClass:"head",style:({
      backgroundImage: 'url(' + _vm.dataInfo.cover + ')'
    })},[_vm._v(" "+_vm._s(_vm.dataInfo.name)+" ")]),_c('div',{staticClass:"g-box"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"con-le"},[_c('img',{staticClass:"img",attrs:{"src":_vm.dataList.image,"alt":""}})]),_c('div',{staticClass:"con-ri",domProps:{"innerHTML":_vm._s(_vm.dataList.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }